import type { OrderKind } from 'store/Settings/types';

// TEMP
export const COLOR = {
  theme: {
    white: '#FFF',
    black: '#000',
    transparent: 'transparent',
    gray: {
      300: '#D2D2D2',
      500: '#9D9D9D',
      800: '#2b2b2b',
      900: '#1C1C1C',
    },
    red: {
      500: '#FF0000',
    },
    purple: {
      500: '#A479B6',
    },
    blue: {
      400: '#00A9F7',
      500: '#0063C5',
    },
    green: {
      500: '#6DCC00',
    },
    orange: {
      500: '#FF5500',
    },
  },
  system: {
    orderKinds: {
      delivery: '#A479B6',
      collection: '#D76C56',
      walk_in: '#DCB441',
      drive_thru: '#49CF77',
      third_party_delivery: '#4CCCD8',
    } satisfies Record<OrderKind, string>,
  },
} as const;

export const SPACING = {
  theme: {
    0: 0,
    1: 1,
    2: 2,
    4: 4,
    6: 6,
    8: 8,
    10: 10,
    12: 12,
    14: 14,
    16: 16,
    18: 18,
    20: 20,
    24: 24,
    28: 28,
    32: 32,
  },
  system: {},
} as const;

export const RADIUS = {
  theme: {
    md: 6,
  },
  system: {},
} as const;

export const FONT_SIZE = {
  theme: {
    '2xs': 8,
    xs: 12,
    sm: 14,
    base: 16,
    lg: 18,
    xl: 20,
    '2xl': 24,
    '3xl': 30,
  },
  system: {},
} as const;

export const FONT_WEIGHT = {
  theme: {
    light: 300,
    normal: 400,
    medium: 500,
    bold: 700,
    black: 900,
  },
  system: {},
} as const;
